<template>
  <div>
    <div id="main" style="width:100%;height:100%;">
        <h1>TicketReportEcharts loading ... </h1>
    </div>
  </div>
</template>

<script>
export default {
  name : 'TicketReportEchartsLine',

  props: ['userId'],

  data() {
      return {
          xAxis_data : [],
          series_data_event : [],
          series_data_ticket : [],
          series_data_close : []
      };
  },

  methods: {
      echartsSetOption() {
        var _this = this;

        // 基于准备好的dom，初始化echarts实例
        var ele = document.getElementById("main");
        var _echarts = echarts.init(ele);

        var _option = {
            toolbox: {
                feature: {
                    magicType: {
                        type: ['line', 'bar', 'stack']
                    },
                    restore: { },
                    saveAsImage: { },
                    dataView: { },
                }
            },

            grid: {
                left : 0,
                top : 0,
                right : 0
            },

            brush: {
            },

            tooltip : {
                trigger : 'axis',
                axisPointer: {
                    type: 'cross'
                },
            },

            legend: {
                data: ['创建工单', '回复工单', '关闭工单']
            },

            xAxis: [
                {
                    type: "category"
                },
            ],

            yAxis: [
                {
                    type: "value"
                }
            ],

            // 鼠标滚轮缩放
            dataZoom: [
                {
                    type: 'inside'
                },
                {
                    type: 'slider'
                }
            ],

            series: [
                 {
                    name: '创建工单',
                    type: "line",
                    markLine : {
                        data : [
                            { type : 'average', name: '创建工单 - 平均' },
                            { type : 'median', name: '创建工单 - 中位数' }
                        ]
                    }
                },
                {
                    name: '回复工单',
                    type: "line",
                    markLine : {
                        data : [
                            { type : 'average', name: '回复工单 - 平均' },
                            { type : 'median', name: '回复工单 - 中位数' }
                        ]
                    }
                },
                {
                    name: '关闭工单',
                    type: "line",
                    markLine : {
                        data : [
                            { type : 'average', name: '关闭工单 - 平均' },
                            { type : 'median', name: '关闭工单 - 中位数' }
                        ]
                    }
                }
            ],
        };

        _option.xAxis[0].data = _this.xAxis_data;
        _option.series[0].data = _this.series_data_event;
        _option.series[1].data = _this.series_data_ticket;
        _option.series[2].data = _this.series_data_close;

        _echarts.setOption(_option, true);

        _echarts.on('datazoom', e => {
            var range = e.batch ? e.batch[0] : e;

            var _from = _this.xAxis_data[Math.floor( (this.xAxis_data.length * range.start ) / 100)];
            var _to = _this.xAxis_data[Math.ceil( (this.xAxis_data.length * range.end ) / 100)];

            _this.$emit('range-change', [_from, _to]);

            console.log('#133 _echarts datazoom', range, _from, _to);
        });
      }
  },

  mounted() {
    var _this = this;

    sdk.TicketReportApi().echartsLine({
        userId: _this.userId
    }).then(res => {
        if ( !res ) {
            _message('echartsLine is enpty');
            return;
        }

        res.forEach(e => {
            _this.xAxis_data.push(e.create_date.substring(0, 10));
            _this.series_data_event.push(e.event_count);
            _this.series_data_ticket.push(e.ticket_count);
            _this.series_data_close.push(e.close_count);
        });

        _this.echartsSetOption();
    });
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/TicketReportEchartsLine.vue